import script from "./form-question.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-question.vue?vue&type=script&setup=true&lang=ts"

import "./form-question.vue?vue&type=style&index=0&id=788ff5f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-788ff5f1"]])

export default __exports__